import { render, staticRenderFns } from "./BaixarModeloArquivo.vue?vue&type=template&id=4e39e493&scoped=true"
import script from "./BaixarModeloArquivo.vue?vue&type=script&lang=js"
export * from "./BaixarModeloArquivo.vue?vue&type=script&lang=js"
import style0 from "./BaixarModeloArquivo.vue?vue&type=style&index=0&id=4e39e493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39e493",
  null
  
)

export default component.exports